import React from "react"
import { Modal, Tag } from "antd"

const QuickEditsModal = ({ open, onClose, data, onImageClick }) => {
  const lang = localStorage.getItem("language") || "ar"

  const generations = data?.detail?.list || []
  const hasData = generations.length > 0

  return (
    <Modal
      title={
        <div>
          <div className="d-flex">
            <div
              className={
                lang === "ar" ? "r-r-modal-icon-arabic" : "r-r-modal-icon"
              }
            >
              <img src="/dashboard/room-redesign-v2.svg" alt="" />
            </div>
            <div>
              <div className="modal-heading" style={{ marginBottom: 0 }}>
                {lang === "ar" ? "تعديلات سريعة" : "Quick Edits"}
              </div>
              <p className="modal-timestamp">
                {hasData
                  ? generations[0].date + " " + generations[0].time
                  : lang === "ar"
                  ? "—"
                  : "—"}
              </p>
            </div>
          </div>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        height: "75vh",
        padding: "0 12px",
      }}
    >
      {/* Fixed Header Section */}
      <div style={{ flex: "0 0 auto", paddingTop: 16 }}>
        <p
          style={{
            fontStyle: "italic",
            marginBottom: 12,
            color: "#555",
          }}
        >
          {hasData
            ? lang === "ar"
              ? `تمت معالجة الصورة وإنشاء ${generations.length} نسخة بنجاح`
              : `Processed image and generated ${generations.length} variations successfully`
            : lang === "ar"
            ? "لا توجد بيانات توليد متاحة"
            : "No generation data available"}
        </p>
        <div className="generation_thread">
          {lang === "ar" ? "سلسلة التوليد" : "Generation Thread"}
        </div>
      </div>

      {/* ✅ Scrollable Cards Section */}
      <div
        className="scrollable-cards"
        style={{
          flex: "1 1 auto",
          overflowY: "auto",
          // paddingRight: "8px",
          marginTop: "10px",
        }}
      >
        {hasData ? (
          generations.map((gen, index) => (
            <div className="quick-edits" key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 10,
                }}
              >
                <span>
                  <span className="count-container">{`0${index + 1}`}</span>{" "}
                  <span className="modal-div-date">
                    &nbsp; {gen.date} {gen.time}
                  </span>
                </span>
                {gen.status === "success" ? (
                  <div>
                    <Tag color="green">
                      {lang === "ar" ? "ناجح" : "Success"}
                    </Tag>
                  </div>
                ) : (
                  <Tag color="red">{lang === "ar" ? "فشل" : "Failed"}</Tag>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 16,
                  flexWrap: "wrap",
                }}
              >
                {/* Input */}
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #eee",
                    borderRadius: "10px",
                    padding: "12px",
                    background: "#fafafa",
                    minWidth: "320px",
                  }}
                >
                  <div className="modal-input-label">
                    {lang === "ar" ? "المدخل" : "Input"}
                  </div>
                  <div>
                    <div>{lang === "ar" ? "طلب المستخدم" : "User prompt"}</div>
                    <p
                      style={{
                        border: "1px solid #ddd",
                        padding: "12px",
                        borderRadius: "4px",
                        marginTop: "5px",
                      }}
                    >
                      {gen.user_prompt}
                    </p>
                    <div
                      style={{ paddingTop: "20px" }}
                      className="modal-input-label"
                    >
                      {lang === "ar" ? "النص المترجم" : "Translated prompt"}
                    </div>
                    <p
                      style={{
                        border: "1px solid #ddd",
                        padding: "12px",
                        borderRadius: "4px",
                        minHeight: "45px",
                      }}
                    >
                      {gen.translated_prompt}
                    </p>
                  </div>
                  <img
                    src={gen.input}
                    alt="input"
                    onClick={() => {
                      if (onImageClick) {
                        onImageClick(
                          gen.input,
                          lang === "ar" ? "تعديلات سريعة" : "Quick Edits"
                        )
                      }
                    }}
                    style={{
                      width: "100%",
                      maxWidth: "100px",
                      height: "100px",
                      borderRadius: "8px",
                      marginTop: "20px",
                      cursor: onImageClick ? "pointer" : "default",
                      transition: "opacity 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      if (onImageClick) {
                        e.currentTarget.style.opacity = "0.8"
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (onImageClick) {
                        e.currentTarget.style.opacity = "1"
                      }
                    }}
                  />
                </div>

                {/* Output */}
                <div
                  style={{
                    flex: 1,
                    border: "1px solid #eee",
                    borderRadius: "10px",
                    padding: "12px",
                    background:
                      gen.status === "failed"
                        ? "#fff5f5"
                        : "rgba(250,250,250,0.9)",
                    minWidth: "280px",
                  }}
                >
                  {gen.status === "failed" ? (
                    <div
                      style={{
                        color: "#d93025",
                        border: "1px solid #f5c2c2",
                        borderRadius: "8px",
                        padding: "10px",
                        fontWeight: 500,
                      }}
                    >
                      {lang === "ar" ? "السبب:" : "Reason:"}
                      <br />
                      <span style={{ color: "red" }}>
                        {gen.reason ||
                          (lang === "ar"
                            ? "لم يتم توفير سبب"
                            : "No reason provided")}
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#404040",
                          paddingBottom: "10px",
                        }}
                      >
                        {lang === "ar" ? "الناتج" : "Output"}
                      </div>
                      <img
                        src={gen.output}
                        alt="output"
                        onClick={() => {
                          if (onImageClick) {
                            onImageClick(
                              gen.output,
                              lang === "ar" ? "تعديلات سريعة" : "Quick Edits"
                            )
                          }
                        }}
                        style={{
                          width: "100%",
                          maxWidth: "100px",
                          height: "100px",
                          borderRadius: "8px",
                          cursor: onImageClick ? "pointer" : "default",
                          transition: "opacity 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          if (onImageClick) {
                            e.currentTarget.style.opacity = "0.8"
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (onImageClick) {
                            e.currentTarget.style.opacity = "1"
                          }
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p
            style={{
              color: "#888",
              textAlign: "center",
              marginTop: 20,
            }}
          >
            {lang === "ar"
              ? "لم يتم العثور على بيانات توليد"
              : "No generation data found"}
          </p>
        )}
      </div>
    </Modal>
  )
}

export default QuickEditsModal
